import { render, staticRenderFns } from "./ImportDevolucionReview.vue?vue&type=template&id=3f51ff7e&scoped=true"
import script from "./ImportDevolucionReview.vue?vue&type=script&lang=js"
export * from "./ImportDevolucionReview.vue?vue&type=script&lang=js"
import style0 from "./ImportDevolucionReview.vue?vue&type=style&index=0&id=3f51ff7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51ff7e",
  null
  
)

export default component.exports